// src/pages/CGVPage.jsx
import React, { useContext } from "react";
import { LanguageContext } from "../contexts/LanguageContext";

export default function CGVPage() {
  const { language } = useContext(LanguageContext);

  const t = {
    FR: {
      title: "Conditions Générales de Vente",
      description:
        "Le document ci-dessous est consultable directement. Si l’aperçu ne se charge pas, vous pouvez le télécharger.",
      download: "Télécharger le document",
    },
    EN: {
      title: "Terms & Conditions of Sale",
      description:
        "The document below can be viewed directly. If the preview doesn’t load, you can download it.",
      download: "Download the document",
    },
  }[language || "FR"];

  const docUrl = "/docs/CGV_barbieri.docx.pdf";

  return (
    <div className="relative min-h-screen flex flex-col py-6 pb-6 gap-6">
      <div
        className="absolute top-0 left-0 w-full h-[33vh] bg-cover bg-no-repeat bg-bottom opacity-80"
        style={{ backgroundImage: "url('/images/decor_005.png')" }}
      ></div>
      <div
        className="absolute top-0 left-0 w-full h-[220px] bg-cover bg-bottom opacity-70"
        style={{ backgroundImage: "url('/images/fond_sakura.png')" }}
      />
      <div className="relative z-10 flex flex-col mt-[33vh] max-w-[1600px] mx-auto px-4 gap-6">
        <h1 className="text-2xl md:text-4xl font-bold text-center text-primary dark:text-blue-300 mb-2">
          {t.title}
        </h1>
        <p className="text-center text-sm md:text-base text-gray-700 dark:text-gray-200 mb-4">
          {t.description}
        </p>

        <div className="flex justify-center mb-4">
          <a
            href={docUrl}
            download
            className="btn btn-primary normal-case"
            target="_blank"
            rel="noreferrer"
          >
            {t.download}
          </a>
        </div>

        <div className="rounded-lg overflow-hidden shadow border border-gray-200 dark:border-gray-700">
          <iframe
            title="CGV PDF"
            src={docUrl}
            className="w-full"
            style={{ height: "80vh" }}
            frameBorder="0"
          />
        </div>
      </div>
    </div>
  );
}
